import { render } from "./StarsReview.vue?vue&type=template&id=4a40ae6c"
import script from "./StarsReview.vue?vue&type=script&lang=js"
export * from "./StarsReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__